module.exports = __webpack_public_path__ + "assets/img/chain-white.6f55bb2d.svg";